// extracted by mini-css-extract-plugin
export default {"contents":"styles_contents__PqKxa"};